import SeoAuditPage from '@/components/SeoAuditPage'

export default function SeoAuditPageWrapper() {
  return <SeoAuditPage />
}

